import { SignIn, useAuth  } from '@clerk/tanstack-react-start'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { Center, Container, Stack, Text, Title } from '@mantine/core'
import { useEffect } from 'react'

export const Route = createFileRoute('/sign-in')({
  validateSearch: (search: Record<string, unknown>) => ({
    redirect_url: (search.redirect_url as string) || '',
  }),
  head: () => ({
    meta: [{ name: 'robots', content: 'noindex, nofollow' }],
  }),
  component: SignInPage,
})

function SignInPage() {
  const { redirect_url } = Route.useSearch()
  const { isSignedIn, isLoaded } = useAuth()
  const navigate = useNavigate()

  // If user is already signed in, redirect them to dashboard
  useEffect(() => {
    if (isLoaded && isSignedIn) {
      if (redirect_url) {
        // Use window.location for full URL redirects (preserves query params)
        window.location.href = redirect_url
      } else {
        navigate({ to: '/dashboard' })
      }
    }
  }, [isLoaded, isSignedIn, redirect_url, navigate])

  return (
    <Container size="xs" py="xl">
      <Stack align="center" gap="xl">
        <Stack align="center" gap="xs">
          <Title order={2}>Sign In</Title>
          <Text c="dimmed" ta="center">
            Sign in to your account to continue
          </Text>
        </Stack>
        <Center>
          <SignIn 
            routing="hash" 
            forceRedirectUrl={redirect_url || '/dashboard'}
            signUpUrl="/sign-up"
          />
        </Center>
      </Stack>
    </Container>
  )
}
